<template>
  <q-slide-item
    :right-color="removeIcon([orderItem]).color"
    class="bg-transparent"
    data-test-id="member-tickets-item"
    @right="resetSlide => $emit('delete', [orderItem], resetSlide)"
    @click="!viewOnly && $emit('edit', orderItem) "
  >
    <template
      v-if="!viewOnly && orderItem.operative && $_.isNil(activityTicket)"
      #right
    >
      <q-icon
        left
        :name="removeIcon([orderItem]).icon"
        @click.stop="resetSlide => $emit('delete', [orderItem], resetSlide)"
      />
      {{ removeIcon([orderItem]).label }}
    </template>

    <q-item
      class="q-px-sm"
      :class="`state-${orderItem.state}`"
      :style="orderItem.state !== 'draft' ? 'cursor: default;' : ''"
    >
      <q-item-section
        v-if="currentCircuit.posOptions.show_images_in_cart && $register"
        top
        class="col column text-center q-mt-xs items-center"
        :style="{ 'max-width': isDrawer || $register || $q.screen.lt.sm ? '50px' : '100px' }"
        avatar
      >
        <q-avatar v-if="$register && user && user.photo">
          <img
            :src="user.photoUrl"
            :alt="user.name"
          >
        </q-avatar>
        <q-avatar
          v-else-if="user && user.firstName"
          color="secondary"
          :text-color="buttonTextColor(currentSite.secondaryColor)"
        >
          {{ user && user.firstName[0] }}
        </q-avatar>
        <q-avatar
          v-else
          class="bg-green-3"
          text-color="white"
        >
          {{ ticketType.displayName[0] }}
        </q-avatar>
      </q-item-section>

      <q-item-section class="col">
        <q-item-label
          :overline="$register"
          :class="$register ? 'text-uppercase' : 'row text-responsive-grey-9'"
        >
          <span
            :class="{ 'col-auto': !$register }"
          >
            {{ register ? orderItem.title : $tc('ticket.memberTicket', 1) }}
          </span>
          <span
            v-if="isDrawer"
            class="parentheses"
          >
            {{ ticketType.displayName }}
          </span>
          <template
            v-if="(orderItem.appliedVoucher || orderItem.discount) && !$register"
          >
            <q-chip
              v-if="orderItem.appliedVoucher"
              rounded
              dense
              :color="orderItem.appliedVoucher.color"
              :text-color="buttonTextColor(orderItem.appliedVoucher.color)"
              size="sm"
              class="q-my-none"
              :label="orderItem.appliedVoucher.label"
              :removable="!viewOnly && orderItem.isUnpaid && orderItem.appliedVoucher.canRemove"
              @remove="orderItem.skipVoucher = true; order.applyRedemptions()"
            />
            <q-chip
              v-else-if="orderItem.voucher"
              rounded
              dense
              :color="orderItem.voucher.color"
              :text-color="buttonTextColor(orderItem.voucher.color)"
              size="sm"
              class="q-my-none"
              :label="orderItem.voucher.label"
              :removable="!viewOnly && orderItem.voucher.canRemove"
              @remove="orderItem.skipVoucher = true; order.applyRedemptions()"
            />
            <q-chip
              v-if="orderItem.discount"
              rounded
              dense
              color="secondary"
              :text-color="buttonTextColor(currentSite.secondaryColor)"
              size="sm"
              class="q-my-none"
              :label="orderItem.discount.displayName"
              :removable="!viewOnly && orderItem.isUnpaid"
              @remove="order.removeDiscount(orderItem)"
            />
            <q-chip
              v-if="orderItem.itemPackage"
              rounded
              dense
              color="secondary"
              text-color="white"
              size="sm"
              :label="orderItem.itemPackage.name"
            />
          </template>
        </q-item-label>
        <q-item-label
          v-if="$register"
        >
          {{ movieOrActivityLabel }}
        </q-item-label>
        <div
          v-else-if="!ticket && !$_.isNil(activityTicket?.activityFormattedTime)"
          class="text-caption text-responsive-grey-8"
        >
          {{ activityTicket.activityFormattedTime }}
        </div>
        <q-item-label v-if="$register || (ticket && ticket.showing.reservedSeating && ticket.seatName)">
          <template v-if="$register">
            <q-chip
              v-if="user"
              dense
              size="md"
              square
            >
              {{ user.displayFirstName }}
            </q-chip>
            <q-chip
              dense
              size="md"
              square
            >
              {{ ticketType.displayName }}
            </q-chip>
          </template>
          <q-chip
            v-if="(ticket && ticket.showing.reservedSeating && ticket.seatName)"
            color="responsive-grey-3"
            dense
            :size="isDrawer || $q.screen.lt.sm ? 'sm' : 'md'"
            square
          >
            Seat {{ ticket.seatName }}
          </q-chip>
          <q-btn
            v-if="$register && !viewOnly && ticket && ticket.showing.reservedSeating && !ticket.seatName"
            class="align-left q-ml-xs"
            color="negative"
            size="sm"
            dense
            outline
          >
            {{ $tc('seatChart.actions.selectSeat', 1) }}
          </q-btn>
          <div
            v-if="!ticket && !$_.isNil(activityTicket?.activityFormattedTime)"
            class="text-caption text-responsive-grey-8"
          >
            {{ activityTicket.activityFormattedTime }}
          </div>
        </q-item-label>
        <q-item-section
          v-if="orderItem.info"
          class="col-auto column q-mt-xs text-info"
        >
          {{ $_.startCase(orderItem.info) }}
        </q-item-section>
        <q-item-label
          v-if="(orderItem.appliedVoucher || orderItem.discount) && $register"
          overline
        >
          <q-chip
            v-if="orderItem.appliedVoucher"
            square
            dense
            :color="orderItem.appliedVoucher.color"
            :text-color="buttonTextColor(orderItem.appliedVoucher.color)"
            size="sm"
            :label="orderItem.appliedVoucher.label"
            :removable="!viewOnly && orderItem.isUnpaid && orderItem.appliedVoucher.canRemove"
            @remove="orderItem.skipVoucher = true; order.applyRedemptions()"
          />
          <q-chip
            v-else-if="orderItem.voucher"
            square
            dense
            :color="orderItem.voucher.color"
            :text-color="buttonTextColor(orderItem.voucher.color)"
            size="sm"
            :label="orderItem.voucher.label"
            :removable="!viewOnly && orderItem.voucher.canRemove"
            @remove="orderItem.skipVoucher = true; order.applyRedemptions()"
          />
          <q-chip
            v-if="orderItem.discount"
            square
            dense
            color="secondary"
            :text-color="buttonTextColor(currentSite.secondaryColor)"
            size="sm"
            :label="orderItem.discount.displayName"
            :removable="!viewOnly && orderItem.isUnpaid"
            @remove="order.removeDiscount(orderItem)"
          />
          <q-chip
            v-if="orderItem.itemPackage"
            square
            dense
            color="secondary"
            text-color="white"
            size="sm"
            :label="orderItem.itemPackage.name"
          />
        </q-item-label>
        <q-item-label
          v-if="!$register"
        >
          <price
            :item="orderItem"
            color="responsive"
          />
        </q-item-label>
      </q-item-section>
      <template v-if="$register">
        <q-item-section
          class="col-auto"
        >
          <price
            :item="orderItem"
          />
        </q-item-section>
        <q-item-section
          class="col-auto row"
        >
          <div class="column reverse justify-start items-center">
            <q-icon
              v-if="orderItem.placed || orderItem.state === 'voided'"
              class="col-auto q-pa-sm"
              :name="orderItem.state === 'paid' ? 'paid' : 'lock'"
              color="grey"
            />
            <q-btn
              v-if="!viewOnly && ticket && orderItem.isRemovable"
              class="col-auto"
              icon="fal fa-trash-can"
              square
              dense
              outline
              :size="isDrawer ? 'xs': undefined"
              @click.stop="resetSlide => $emit('delete', [orderItem], resetSlide)"
            >
              <q-tooltip>Click or swipe to remove this ticket</q-tooltip>
            </q-btn>
          </div>
        </q-item-section>
      </template>
      <q-item-section
        v-else-if="ticket"
        top
        side
        class="col-auto row justify-between"
      >
        <q-item-label class="d-flex">
          <q-btn
            v-if="!viewOnly && ticket && orderItem.isRemovable"
            class="col-auto"
            :class="{ 'q-pa-xs': isDrawer }"
            icon="fal fa-trash-can"
            color="responsive-grey-2"
            text-color="responsive"
            :dense="isDrawer"
            round
            :size="isDrawer && $consumer ? 'sm': 'md'"
            @click.stop="resetSlide => $emit('delete', [orderItem], resetSlide)"
          >
            <q-tooltip>Click or swipe to remove this ticket</q-tooltip>
          </q-btn>

          <q-chip
            class="bg-transparent"
            text-color="responsive"
            flat
            square
          >
            1
          </q-chip>
        </q-item-label>
      </q-item-section>
      <q-item-section
        v-else
        top
        side
        class="col-auto row justify-between"
      >
        <item-add-and-remove-buttons
          class="row"
          :activity-ticket="activityTicket"
          :is-drawer="isDrawer"
        />
      </q-item-section>
    </q-item>
  </q-slide-item>
</template>

<script>
import OrderItem from 'src/models/order-item/OrderItem'
import ItemAddAndRemoveButtons from 'src/modules/register/components/activities/ItemAddAndRemoveButtons'
import Price from 'src/modules/register/components/cart/Price'
export default {
  name: 'MemberTicketsItem',
  configuration: ['currentSite', 'currentCircuit'],
  components: {
    Price,
    ItemAddAndRemoveButtons
  },
  inject: ['order'],
  props: {
    orderItem: {
      type: OrderItem,
      required: true,
      default: null
    },
    isDrawer: {
      type: Boolean,
      required: false,
      default: false
    },
    defaultOpened: {
      type: Boolean,
      required: false,
      default: true
    },
    viewOnly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['delete', 'edit'],
  computed: {
    ticket () {
      return this.orderItem.ticket
    },
    activityTicket () {
      return this.orderItem.activityTicket
    },
    ticketType () {
      if (this.ticket) {
        return this.ticket.ticketType
      } else if (this.activityTicket) {
        return this.activityTicket.ticketType
      } else {
        return null
      }
    },
    user () {
      if (this.ticket) {
        return this.ticket.user
      } else if (this.activityTicket) {
        return this.activityTicket.user
      } else {
        return null
      }
    },
    movieOrActivityLabel () {
      if (this.ticket) {
        return `${this.ticket.showing.movie.name} - ${this.ticket.showing.formattedTime()}`
      } else if (!_.isNil(this.activityTicket?.activityLabel)) {
        return this.activityTicket.activityLabel
      } else {
        return ''
      }
    }
  },
  methods: {
    removeIcon (orderItems) {
      const orderItem = orderItems[0]
      if (orderItem.state === 'draft') {
        return {
          icon: 'delete',
          color: 'warning',
          label: 'Remove' + (orderItems.length > 1 ? ' All' : '')
        }
      } else if (orderItem.placed && orderItem.pickPrepPrintingStatus === 'success') {
        return {
          icon: 'delete',
          color: 'negative',
          label: 'Void' + (orderItems.length > 1 ? ' All' : '')
        }
      } else if (orderItem.placed) {
        return {
          icon: 'delete',
          color: 'negative',
          label: 'Void' + (orderItems.length > 1 ? ' All' : '')
        }
      } else {
        return {}
      }
    },
    buttonTextColor (color) {
      // when return hex code
      if (color.startsWith('#')) return this.$isColorDark(color) ? 'white' : 'black'
      // when return value from colorOptions
      const colorHex = this.$getSiteColorHex(this.currentSite, color)
      if (!colorHex) return false
      return this.$isColorDark(colorHex) ? 'white' : 'black'
    }
  }
}

</script>
<style lang="scss" scoped>
  .q-btn--round.col-auto {
    padding: 0;
    min-height: 3em;
    min-width: 3em
  }
</style>
